export const PUBLISHED = 'published';
export const NOT_PUBLISHED = 'not_published';

export const NEWS_STATUSES = {
  [PUBLISHED]: 'news.published',
  [NOT_PUBLISHED]: 'news.not_published',
};
